<div class="flex gap-3 items-center">
  <app-input
    [(value)]="value"
    placeholder="카테고리명을 입력해주세요."
    class="w-full"
  />
  <app-button (click)="cancel.emit()" variant="outline" color="gray"
    >취소</app-button
  >
  <app-button (click)="submit.emit()">저장</app-button>
</div>
